/* eslint-disable no-shadow */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';

// Relative import
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import {
  setIsToggleOn,
  setIsClickConfirmOrder,
  addUploadedOrderImage,
  setIsValidOrder,
} from '../../../actions/order';
import {
  setIsShowSMSVerfiyDialog,
  setIsSendingSMS,
  setIsShowSMSVerfiyLoadingDialog,
} from '../../../actions/dialog';
import { localStorageGet } from '../../../service/localStorage';
import { sendSMS } from '../../../api/user';

import s from '../../../assets/styles/style.sass';
import s2 from './Order21Confirm.sass';

class Order21Confirm extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    onClickConfirm: PropTypes.func.isRequired,
    setIsClickConfirmOrder: PropTypes.func.isRequired,
    setIsShowSMSVerfiyDialog: PropTypes.func.isRequired,
    isClickConfirmOrder: PropTypes.bool.isRequired,
    setIsSendingSMS: PropTypes.func.isRequired,
    setIsValidOrder: PropTypes.func.isRequired,
    isSendingSMS: PropTypes.bool.isRequired,
    isValidOrder: PropTypes.bool.isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);
    this.onClickSumbitOrder = this.onClickSumbitOrder.bind(this);
  }

  onClickSumbitOrder() {
    this.props.setIsClickConfirmOrder(true);
    // init isValid value to true for checking
    this.props.setIsValidOrder(true);
    // get time to check order
    if (localStorageGet('auth.verified', false)) {
      setTimeout(() => {
        if (!this.props.isValidOrder) {
          this.props.setIsClickConfirmOrder(false);
        } else {
          // delay the click actiion, because need some time to do checking
          this.props.onClickConfirm();
        }
      }, 500);
    } else if (!this.props.isSendingSMS) {
      sendSMS(this.props.currentLocale, this.props.setIsSendingSMS);
      this.props.setIsShowSMSVerfiyDialog();
    }
  }

  render() {
    return (
      <div>
        <br />
        <button
          className={`${s.button} ${s.primary} ${s.globalTextBlue}`}
          style={{ width: '100%' }}
          onClick={e => {
            if (!this.props.isClickConfirmOrder) {
              e.preventDefault();
              this.onClickSumbitOrder();
            } else if (!localStorageGet('auth.verified', false)) {
              this.props.setIsShowSMSVerfiyDialog();
            }
          }}
        >
          {this.props.modelDataText.order_review_order_button}
        </button>
      </div>
    );
  }
}

const mapState = state => ({
  currentLocale: state.intl.locale,
  isToggleOn: state.order.isToggleOn,
  isSendingSMS: state.dialog.isSendingSMS,
  images: state.order.images,
  isValidOrder: state.order.isValidOrder,
  isClickConfirmOrder: state.order.isClickConfirmOrder,
});

const mapDispatch = {
  setIsToggleOn,
  setIsClickConfirmOrder,
  setIsShowSMSVerfiyDialog,
  setIsSendingSMS,
  setIsShowSMSVerfiyLoadingDialog,
  addUploadedOrderImage,
  setIsValidOrder,
};

export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order21Confirm),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order21Confirm/Order21Confirm.js